import { BLACK, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getFullPageSectionStyles = props => {
  var _props$noPadding = props.noPadding,
    noPadding = _props$noPadding === void 0 ? false : _props$noPadding,
    _props$horizontalAlig = props.horizontalAlignment,
    horizontalAlignment = _props$horizontalAlig === void 0 ? 'center' : _props$horizontalAlig,
    _props$verticalAlignm = props.verticalAlignment,
    verticalAlignment = _props$verticalAlignm === void 0 ? 'center' : _props$verticalAlignm;
  var alignmentValue = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end'
  };
  return StyleSheet.create({
    backdrop: {
      height: '100%',
      width: '100%',
      backgroundColor: BLACK,
      opacity: 0.35,
      zIndex: 1
    },
    closeButton: {
      position: 'absolute',
      top: 10,
      right: 8,
      zIndex: 2
    },
    children: Object.assign(Object.assign({
      flex: 1
    }, !noPadding && {
      padding: tokens.spacing.SPACING_16
    }), {
      zIndex: 2,
      alignItems: alignmentValue[horizontalAlignment],
      justifyContent: alignmentValue[verticalAlignment]
    })
  });
};